import Form from "@rjsf/bootstrap-4";
import React from "react";
import getDataFromApi from "../../../../components/getDataFromApi";
import { CustomWidget } from "../../../../components/widgets/CustomWidgets";
import { getCokkie } from "../../../login/Login";
export default function Deploy() {
  let cokkie = getCokkie("jwtToken");
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${cokkie}`);
  var definetask = {};
  const [data, setData] = React.useState({});
  React.useEffect(() => {
    getDataFromApi(
      `${window["ENV"].API_URL}/forms/deploy_model`,
      "GET"
    )
      .then((result) => {
        setData(result);
        console.log(result);
      })
      .catch((e) => alert(e.message));
    console.log(data);
  }, []);
  const save = async () => {
    var urlencoded = JSON.stringify(definetask.formData);
    var requestOptions2 = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
    };
    fetch(
      `${window["ENV"].API_URL}/forms/deploy_model`,
      requestOptions2
    )
      .then((response) => response.json())
      .then((result) => alert(result?.detail ?? result));
  };
  const schema = { ...data };

  const uiSchema = {};

  const onSubmit = ({ formData }, e) => {
    definetask = { formData };
    console.log(definetask.formData);
    save();
  };
  return (
    <div>
      <Form
        schema={schema}
        FieldTeuiSchema={uiSchema}
        widgets={CustomWidget}
        onSubmit={onSubmit}
        className="rjsf deploy"
      />
    </div>
  );
}
